import { AnalyticsBrowser } from "@segment/analytics-next";
import { discoverService } from "app/discover-service";

const analytics = AnalyticsBrowser.load({
  writeKey: discoverService("SEGMENT_KEY"),
});

export default analytics;
